import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "semantic-ui-react";
import { selectTranslations } from "../../../config/i18n/slice";
import { toast } from "react-toastify";
import useGetJsonDataFromExcelFile from "../../../../hooks/useGetJsonDataFromExcelFile";
import { useHistory } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { CloseIcon } from "../../../../Assets/Icons/svg";
import { createBulkJobtitle } from "../../../config/api/jobTitleApis";
import { checkNullValue } from "../../../config/common/commonFunctions";
function JobtitleBulkUploadModal({
  isOpen = false,
  setModalOpenState = () => {},
  handleSuccess = () => {},
}) {
  const t = useSelector(selectTranslations);
  const history = useHistory();
  const { getJsonDataFromExcelFile } = useGetJsonDataFromExcelFile();
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  const handleBrowseButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const organisationId = useSelector((state) => {
    if (state?.auth?.user?.organisation) {
      return state.auth.user.organisation.id;
    } else {
      return null;
    }
  });
  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });

  useEffect(() => {
    return () => {
      setSelectedFile(null);
    };
  }, [isOpen]);
  const handleCategoryCreate = async () => {
    if (
      selectedFile &&
      (selectedFile.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        selectedFile.type === "application/vnd.ms-excel")
    ) {
      let jsonData = await getJsonDataFromExcelFile(
        selectedFile,
        [t.categories.table.ID, t.jobTitle.table.name],
        "jobTitle"
      );

      if (jsonData && jsonData.length) {
        const filteredData = jsonData.filter((item) => {
          return !checkNullValue(item);
        });

        if (filteredData?.length > 201) {
          return toast.error(t.assets.max_length_error);
        }

        let res = await createBulkJobtitle(filteredData, organisationId);
        if (res && res?.status == 200) {
          handleSuccess(res);
        } else if (res?.error) {
          toast.error(res?.error);
        } else {
          toast.error(t.common.something_went_wrong);
        }
      }
    } else {
      toast.error(t.categories.upload_excel_jobtitle_file);
    }
  };

  const handleDownload = () => {
    const downloadLink = document.createElement("a");
    downloadLink.href = toAbsoluteUrl(
      selectedLanguage == "en"
        ? "/media/sample-xls/jobTitle-en.xlsx"
        : "/media/sample-xls/jobTitle-ar.xlsx"
    );
    downloadLink.download =
      selectedLanguage == "en" ? "jobTitle-sample.xlsx" : "مسمى وظيفي.xlsx"; // Set the desired file name

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };
  return (
    <Modal
      className="assets-modal"
      size="tiny"
      open={isOpen}
      onClose={() => setModalOpenState(false)}
    >
      <div className="header-container">
        <span className="assets-header">{t.jobTitle.import_job_titles}</span>
        <div>
          <span
            className="c-pointer text-right"
            onClick={() => setModalOpenState(false)}
          >
            <CloseIcon />
          </span>
        </div>
      </div>

      <Modal.Content>
        <span className="assets-label">{t.jobTitle.uplaod_job_titles}</span>

        <div className="modal-input">
          <div
            class={`small-box ${
              selectedLanguage == "en" ? "text-left" : "text-right"
            }`}
          >
            <label
              className={`text-label ${
                selectedLanguage == "en" ? "ml-2" : "mr-2"
              }`}
            >
              {selectedFile?.name}
            </label>
          </div>
          <input
            id="barcodePopup"
            type="file"
            hidden
            className="file-input"
            ref={fileInputRef}
            fluid
            onChange={(e) => {
              if (e.target.files && e.target.files.length) {
                setSelectedFile(e.target.files[0]);
              }
            }}
          />
          <button onClick={handleBrowseButtonClick} className="browse-btn">
            {t.assets.browse_btn}
          </button>
        </div>

        <div
          className="buttun-type-link mt-5 c-pointer"
          style={{ color: "#0C66E4" }}
          basic
          onClick={handleDownload}
        >
          {t.jobTitle.xls}
        </div>
      </Modal.Content>

      <div
        className={`modal-button-container ${
          selectedLanguage == "en" ? "mr-6" : "ml-10"
        }`}
      >
        <button
          onClick={() => setModalOpenState(false)}
          className="modal-form-action-button black"
        >
          {t.common.cancel}
        </button>

        <button
          onClick={() => handleCategoryCreate()}
          className="modal-form-action-button light-blue"
        >
          {t.categories.import}
        </button>
      </div>
    </Modal>
  );
}

export default JobtitleBulkUploadModal;
